import { IPageDetails, ISPageDetails } from '@/shared/services/forms/forms.types';

export function getStructuredPageDetails(pageDetailsObj: IPageDetails): ISPageDetails {
	return {
		totalCount: pageDetailsObj.total_count || NaN,
		offset: pageDetailsObj.offset,
		pageSize: pageDetailsObj.page_size,
		hasNext: pageDetailsObj.has_next,
		sortingOrder: pageDetailsObj.sorting_order,
		sortingType: pageDetailsObj.sorting_type,
	};
}
